module.exports = __webpack_public_path__ + "static/media/Ally_app_6.f96a36e0.jpg";